/*
 * @Author: Vanny
 * @Date: 2018-09-13 14:42:29
 * @LastEditors: Vanny
 * @LastEditTime: 2020-02-27 14:32:01
 * @Description: 路由
 */
import Vue from 'vue'
import Router from 'vue-router'

import HomeView from '../views/HomeView'
import SearchView from '../views/SearchView'
import ServiceView from '../views/ServiceView'
import ProblemList from '../views/ProblemList'
import AnswerView from '../views/AnswerView'
import FeedbackView from '../views/FeedbackView'
import ExternalLink from '../views/ExternalLink'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        title: 'help_center',
        hideClose: true,
        hideFooter: true,
      },
      component: HomeView,
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        title: 'help_center',
        hideClose: true,
        hideFooter: true,
      },
      component: HomeView,
    },
    {
      path: '/search',
      name: 'search',
      meta: {
        title: 'search',
      },
      component: SearchView,
    },
    {
      path: '/service',
      name: 'service',
      meta: {
        name: 'name',
      },
      component: ServiceView,
    },
    {
      path: '/list',
      name: 'list',
      meta: {
        name: 'name',
      },
      component: ProblemList,
    },
    {
      path: '/detail',
      name: 'detail',
      meta: {
        title: 'detail',
        // enableShare: true,
      },
      component: AnswerView,
    },
    {
      path: '/feedback',
      name: 'feedback',
      meta: {
        title: 'feedback',
      },
      component: FeedbackView,
    },
    {
      path: '/feed',
      name: 'feed',
      meta: {
        title: 'feedback',
        hideFooter: true,
      },
      component: FeedbackView,
    },
    {
      path: '/extra-link',
      name: 'extra-link',
      meta: {
        name: 'name',
      },
      component: ExternalLink,
    },
  ],
})



// WEBPACK FOOTER //
// ./src/views/help-center/router/index.js